import { render, staticRenderFns } from "./UserExpress.vue?vue&type=template&id=0b1e24a0&"
import script from "./UserExpress.vue?vue&type=script&lang=js&"
export * from "./UserExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports